module.exports = __webpack_public_path__ + "media/images/social/social-icon-odn-6b67fa33fe7163587313d932682efb39.svg";